import { FC } from "react";
import { StockNumberInputProps } from "../../utils/interfaces";
import { InputLabelDescription } from "../InputLabelDescription";
import { NumberField } from "../fields";

/**
 * A price the reader sets: the limit, or the stop.
 *
 * Two things beyond the chrome were wrong here. It held a `defaultValue` of
 * 0 while ignoring the value antd's form handed it, so the field showed a
 * figure the form did not have — an untouched field reading "$ 0" that the
 * required rule then rejected as empty. And it had no placeholder, so there
 * was nothing to tell a reader that the zero was not their answer.
 *
 * Now it forwards the form's value and shows a placeholder until there is
 * one, which is the honest state of a field nobody has filled in.
 */
export const StockNumberInput: FC<StockNumberInputProps> = ({
  leftLabel,
  rightLabel,
  onChange,
  value,
  id,
}) => {
  const handleChangeStockPrice = (next: number) => {
    onChange(next);
  };

  return (
    <>
      <InputLabelDescription
        label={leftLabel}
        description={rightLabel}
        htmlFor={id}
      />
      <NumberField
        id={id}
        value={value}
        min={0}
        placeholder="$ 0.00"
        formatter={(v) =>
          v === "" || v === undefined || v === null
            ? ""
            : `$ ${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }
        parser={(v) => v.replace(/[^\d.]/g, "")}
        onChange={handleChangeStockPrice}
      />
    </>
  );
};
